/*
 * @FilePath     : /mpx-es-ui/src/creator/createPage.js
 * @Author       : LiYang
 * @Date         : 2021-08-12 17:00:41
 * @LastEditTime : 2021-12-23 21:18:04
 * @LastEditors  : Please set LastEditors
 * @Description  : 生命周期转换
 */
import { createPage } from '@mpxjs/core'
import creator from './common'

export default creator(createPage, 'page')
